import { ProviderMedicalRole } from '@uplift/types';
import { restClient } from '../client';
import { MatchingProfileData } from './provider';
import { AvailabilityDayOfWeekInterval, AvailabilityTimeOfDayInterval, SessionServiceType } from '../resources';
import snakecaseKeys from 'snakecase-keys';

export type GetMatchesInput = {
  seed: number;
  stateId: string;
  medicalRole: ProviderMedicalRole;
  modalityId?: string;
  ageGroupId?: string;
  rematch?: boolean;
  visitType?: SessionServiceType | null;
  insuranceCompanyId?: string | null;
  visitReasonIds?: string[];
  faithIds?: string[];
  genderIds?: string[];
  ethnicityIds?: string[];
  communityExpertise?: {
    faithIds?: string[];
    ethnicityIds?: string[];
    generalIds?: string[];
  };
  availableWeekdays?: AvailabilityDayOfWeekInterval[];
  availableDayIntervals?: AvailabilityTimeOfDayInterval[];

  languageIds?: string[];
  treatmentApproachIds?: string[];

  // used in psych referral flow
  patientId?: string | null;
  filteringType?: 'strict' | 'relaxed';
};

export enum MatchingProvidersType {
  cashpay = 'cashpay',
  insurance = 'insurance',
}

export type GetMatchesOutput = {
  data: {
    matchingProfiles: MatchingProfileData[];
    type: MatchingProvidersType;
    emptyListRelaxed: boolean;
    noInsuranceProviders: boolean;
  };
};

export const getMatches = (data: GetMatchesInput) => restClient.request<GetMatchesOutput>('/api/v1/matching_profile/search', { method: 'POST', data: snakecaseKeys(data) });

export type GetStateHasPsychiatristsResponse = {
  // boolean represents if there are psychiatrists in the state
  data: boolean;
};

export const getStateHasPsychiatrists = (stateId: string) => restClient.request<GetStateHasPsychiatristsResponse>(`/api/v1/matching/state_has_psychiatrists/${stateId}`);
